import React from 'react'
import { CloseButton } from './Button'

/** Compact remove control for media thumbnails and editable list rows. */
export const RemoveButton = React.forwardRef<HTMLButtonElement, React.ComponentProps<typeof CloseButton>>(
  (props, ref) => (
    <CloseButton
      ref={ref}
      type="button"
      w="24px"
      h="24px"
      minW="24px"
      p="2px"
      bg="white"
      borderRadius="full"
      color="black"
      position="absolute"
      top="4px"
      {...props}
    />
  )
)

RemoveButton.displayName = 'RemoveButton'
